class RandomColor {
  public getRandomColor(): string {
    const maxVal = 0xffffff; // 16777215
    let randomNumber: any;
    randomNumber = Math.random() * maxVal;
    randomNumber = Math.floor(randomNumber);
    randomNumber = randomNumber.toString(16);
    const randColor = randomNumber.padStart(6, 0);
    return '#' + randColor.toUpperCase();
  }
}

export const RandomColorGenerator = new RandomColor();
